const RELOAD_ATTEMPT_STORAGE_KEY = 'new-app-version-reload-attempt';

const versionAttemptedBeforeThisLoad = sessionStorage.getItem(RELOAD_ATTEMPT_STORAGE_KEY);

export const hasReloadAttemptFor = (version: string) => versionAttemptedBeforeThisLoad === version;

export const reloadToVersion = (version: string) => {
  sessionStorage.setItem(RELOAD_ATTEMPT_STORAGE_KEY, version);
  window.location.reload();
};
